import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { handleSortModelChanged } from 'src/utils/sorting';
import config from 'src/config';
import AgGridTable from 'src/components/helpers/AgGridTable';
import { GridCard } from 'src/components/helpers/GridCard';

import style from './style.module.css';

const CompaniesTableComponent = ({
  data,
  events,
  onYearFilterChange,
  onCompaniesSortingChange,
  onGetNextPageData,
  onRowDoubleClicked,
}) => {
  const onGridReady = useCallback(params => {
    params.api.sizeColumnsToFit();
  }, []);

  const companies = data.get('companies');
  const isFetching = data.get('loadingCompanies');
  const columnDefs = config.tables.getIn(['tradeShowCompaniesTable', 'columnDefs']);

  const createYearFilterList = () => {
    const years = events.map(event => event.year);

    return years.filter((year, index, array) => array.indexOf(year) === index).sort();
  };

  const onSort = sortModel => {
    handleSortModelChanged(sortModel, data, onCompaniesSortingChange);
  };

  const getRowNodeId = data => data.id;

  const yearFilter = (
    <>
      <label className="field-label mb0" htmlFor="tradeShowYearFilter">
        Year
      </label>
      <select
        className={classNames(style.year, 'form-control')}
        defaultValue="All"
        id="tradeShowYearFilter"
        onChange={event => onYearFilterChange(event.target.value)}
      >
        <option value="All">All</option>
        {createYearFilterList().map(year => (
          <option key={year.toString()} value={year}>
            {year}
          </option>
        ))}
      </select>
    </>
  );

  return (
    <GridCard actions={yearFilter} className={style.host} title="Companies" dense>
      <AgGridTable
        columnDefs={columnDefs}
        getRowNodeId={getRowNodeId}
        isFetching={isFetching}
        onGetNextPageData={onGetNextPageData}
        onGridReady={onGridReady}
        onRowDoubleClicked={onRowDoubleClicked}
        onSortModelChanged={onSort}
        page={data.get('companiesCurrentPage')}
        rowData={companies}
        totalPages={data.get('companiesTotalPages')}
        sortable
      />
    </GridCard>
  );
};

CompaniesTableComponent.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
  events: PropTypes.instanceOf(Array).isRequired,
  onCompaniesSortingChange: PropTypes.func,
  onGetNextPageData: PropTypes.func,
  onRowDoubleClicked: PropTypes.func,
  onYearFilterChange: PropTypes.func,
};

/** Companies table component. */
export const CompaniesTable = memo(CompaniesTableComponent);
